import { render, staticRenderFns } from "./UpdateForumCategoryPage.vue?vue&type=template&id=970fde6e&scoped=true"
import script from "./UpdateForumCategoryPage.vue?vue&type=script&lang=js"
export * from "./UpdateForumCategoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970fde6e",
  null
  
)

export default component.exports